import type { UnknownAction } from "redux";

import type {
  CreateFormIdVariant,
  CreateFormUpdateCommonValuesAction,
  CreateFormUpdateSpecificValuesAction,
  CreateResult,
  InitializeCreateFormAction,
  RequestCleanupCreateFormAction,
} from "./createFormActions";
import type { CreateValidationErrors } from "./createReducer";

export type CreateMetaActions =
  | SubmitStartAction
  | SubmitFinishedAction
  | SetCreateResultAction
  | InitializeCreateFormAction
  | RequestCleanupCreateFormAction
  | CreateFormUpdateCommonValuesAction
  | CreateFormUpdateSpecificValuesAction
  | EnableExtendedModeAction;

export interface SubmitStartAction extends UnknownAction {
  payload: {
    formId: CreateFormIdVariant;
  };
  type: "CREATE_FORM:SUBMIT_START";
}

export const startSubmit = (
  formId: CreateFormIdVariant,
): SubmitStartAction => ({
  payload: {
    formId,
  },
  type: "CREATE_FORM:SUBMIT_START",
});

export interface SubmitFinishedAction extends UnknownAction {
  payload: {
    formId: CreateFormIdVariant;
  };
  type: "CREATE_FORM:SUBMIT_FINISHED";
}

export const finishSubmit = (
  formId: CreateFormIdVariant,
): SubmitFinishedAction => ({
  payload: {
    formId,
  },
  type: "CREATE_FORM:SUBMIT_FINISHED",
});

export interface SetCreateResultAction extends UnknownAction {
  payload: {
    formId: CreateFormIdVariant;
    result: CreateResult | null;
    validationErrors: CreateValidationErrors;
  };
  type: "CREATE_FORM:SET_CREATE_RESULT";
}

export const setCreateResult = (
  formId: CreateFormIdVariant,
  result: CreateResult,
  validationErrors: CreateValidationErrors = { common: {}, specific: {} },
): SetCreateResultAction => ({
  payload: {
    formId,
    result,
    validationErrors,
  },
  type: "CREATE_FORM:SET_CREATE_RESULT",
});

export interface EnableExtendedModeAction extends UnknownAction {
  payload: { formId: CreateFormIdVariant };
  type: "CREATE_FORM:ENABLE_EXTENDED_MODE";
}

export const enableExtendedMode = (
  formId: CreateFormIdVariant,
): EnableExtendedModeAction => ({
  payload: { formId },
  type: "CREATE_FORM:ENABLE_EXTENDED_MODE",
});
